<template>
  <div class="answer-page" v-loading="loading">
    <template v-if="!loading && exam">
      <!-- 顶部信息栏 -->
      <header class="answer-header">
        <div class="header-left">
          <h2 class="exam-title">{{ exam.examName }}</h2>
          <span class="submit-status" v-if="record.status === '2'">已提交</span>
        </div>
        <div class="header-right">
          <div class="timer" :class="{ danger: remainSeconds < 300 }" v-if="record.status === '1'">
            <i class="el-icon-alarm-clock"></i>
            <span>剩余时间：{{ formatTime(remainSeconds) }}</span>
          </div>
          <el-button v-if="record.status === '1'" type="primary" size="small" @click="handleSubmitAll">
            提交试卷
          </el-button>
          <el-button v-else type="primary" size="small" plain @click="goBack">返回考试列表</el-button>
        </div>
      </header>

      <div class="answer-body">
        <!-- 题目区 -->
        <div class="problem-area">
          <div v-if="problems.length === 0" class="empty-tip">本场考试暂无题目</div>
          <div v-for="(problem, index) in problems" :key="problem.examProblemId" class="problem-card">
            <div class="problem-header">
              <span class="problem-index">{{ index + 1 }}</span>
              <el-tag size="mini" :type="tagType(problem.type)">{{ formatType(problem.type) }}</el-tag>
              <span class="problem-score">{{ problem.score }} 分</span>
              <el-tag v-if="problem.isCorrect !== null && problem.isCorrect !== undefined"
                      size="mini" :type="problem.isCorrect === '1' ? 'success' : 'danger'" class="result-tag">
                {{ problem.isCorrect === '1' ? '正确' : '错误' }}
              </el-tag>
            </div>
            <div class="problem-content">{{ problem.content }}</div>
            <div class="option-list">
              <div v-for="option in problem.options" :key="option.key" class="option-item"
                   :class="optionClass(problem, option)">
                <template v-if="problem.type === 'multiple'">
                  <el-checkbox :value="isChecked(problem, option.key)"
                               :disabled="record.status === '2'"
                               @change="handleMultipleChange(problem, option.key)">
                    <span class="option-label">{{ option.key }}.</span>
                    <span class="option-content">{{ option.content }}</span>
                  </el-checkbox>
                </template>
                <template v-else>
                  <el-radio :value="problem.userAnswer" :label="option.key"
                            :disabled="record.status === '2'"
                            @change="handleSingleChange(problem, option.key)">
                    <span class="option-label">{{ option.key }}.</span>
                    <span class="option-content">{{ option.content }}</span>
                  </el-radio>
                </template>
              </div>
            </div>
            <!-- 已提交后展示答案解析 -->
            <div v-if="record.status === '2'" class="answer-analysis">
              <span class="analysis-item">你的答案：<strong>{{ problem.userAnswer || '未作答' }}</strong></span>
              <span class="analysis-item">正确答案：<strong class="correct">{{ problem.correctAnswer }}</strong></span>
            </div>
          </div>
        </div>

        <!-- 答题卡 -->
        <aside class="answer-sheet">
          <h3 class="sheet-title">答题卡</h3>
          <div class="sheet-grid">
            <div v-for="(problem, index) in problems" :key="index"
                 class="sheet-item"
                 :class="sheetItemClass(problem)"
                 @click="scrollToProblem(index)">
              {{ index + 1 }}
            </div>
          </div>
          <div class="sheet-legend">
            <span><i class="legend-dot answered"></i>已作答</span>
            <span><i class="legend-dot unanswered"></i>未作答</span>
          </div>
          <div class="sheet-summary">
            共 {{ problems.length }} 题，已答 {{ answeredCount }} 题
          </div>
        </aside>
      </div>
    </template>
  </div>
</template>
<script>
import api from '@/common/api';
import storage from '@/common/storage.js';
export default {
  name: 'PortalCustomizeExamAnswer',
  data() {
    return {
      loading: false,
      exam: null,
      record: {},
      problems: [],
      remainSeconds: 0,
      timer: null,
      submitting: false
    }
  },
  computed: {
    answeredCount() {
      return this.problems.filter((item) => item.userAnswer && item.userAnswer.length > 0).length;
    }
  },
  created() {
    let recordId = this.$route.query.recordId;
    if (!recordId) {
      this.$message.error('缺少考试记录参数');
      this.$router.push('/portal/customize/exam').catch(() => {});
      return;
    }
    this.queryDetail(recordId);
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    queryDetail(recordId) {
      this.loading = true;
      api.hoj_customize_exam_detail({ recordId: recordId }).then((r) => {
        if (r.data.code === "200") {
          let data = r.data.data;
          this.exam = data.exam;
          this.record = data.record;
          this.problems = (data.problems || []).map((item) => {
            // 多选题回显勾选状态
            if (item.type === 'multiple' && item.userAnswer) {
              item.userAnswers = item.userAnswer.split(',');
            }
            return item;
          });
          this.remainSeconds = data.remainSeconds || 0;
          if (this.record.status === '1') {
            this.startTimer();
          }
        } else {
          this.$message.error(r.data.msg || '查询考试详情失败');
        }
      }).catch(() => {
        // 未登录(401)已由 common/api.js 统一跳转门户登录页，这里不重复提示
      }).finally(() => {
        this.loading = false;
      });
    },
    startTimer() {
      this.clearTimer();
      this.timer = setInterval(() => {
        if (this.remainSeconds > 0) {
          this.remainSeconds--;
        } else {
          this.clearTimer();
          this.autoSubmit();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    formatTime(seconds) {
      if (seconds < 0) seconds = 0;
      let h = Math.floor(seconds / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let s = seconds % 60;
      return [h, m, s].map((v) => (v < 10 ? '0' + v : v)).join(':');
    },
    formatType(type) {
      const map = { single: '单选题', multiple: '多选题', truefalse: '判断题' };
      return map[type] || type;
    },
    tagType(type) {
      const map = { single: '', multiple: 'success', truefalse: 'warning' };
      return map[type] || '';
    },
    isChecked(problem, key) {
      return (problem.userAnswers || []).indexOf(key) > -1;
    },
    // 选项样式：已提交后正确选项标绿、选错标红
    optionClass(problem, option) {
      if (this.record.status !== '2') {
        return {};
      }
      let isCorrectOption = (problem.correctAnswer || '').split(',').indexOf(option.key) > -1;
      let isUserOption = (problem.userAnswer || '').split(',').indexOf(option.key) > -1;
      if (isCorrectOption) {
        return { 'option-correct': true };
      }
      if (isUserOption && !isCorrectOption) {
        return { 'option-wrong': true };
      }
      return {};
    },
    // 单选与判断题选择
    handleSingleChange(problem, key) {
      if (this.record.status === '2') {
        return;
      }
      problem.userAnswer = key;
      this.submitAnswer(problem, key);
    },
    // 多选题勾选
    handleMultipleChange(problem, key) {
      if (this.record.status === '2') {
        return;
      }
      let answers = problem.userAnswers || [];
      let idx = answers.indexOf(key);
      if (idx > -1) {
        answers.splice(idx, 1);
      } else {
        answers.push(key);
      }
      answers.sort();
      problem.userAnswers = answers;
      problem.userAnswer = answers.join(',');
      this.submitAnswer(problem, problem.userAnswer);
    },
    // 逐题提交答案
    submitAnswer(problem, userAnswer) {
      api.hoj_customize_exam_answer({
        recordId: this.record.recordId,
        examId: this.exam.id,
        problemId: problem.problemId,
        examProblemId: problem.examProblemId,
        userAnswer: userAnswer
      }).then((r) => {
        if (r.data.code !== "200") {
          this.$message.error(r.data.msg || '答案保存失败');
        }
      }).catch(() => {
        // 未登录(401)已由 common/api.js 统一跳转门户登录页
      });
    },
    // 全部提交
    handleSubmitAll() {
      let unanswered = this.problems.length - this.answeredCount;
      let tip = unanswered > 0
          ? '还有 ' + unanswered + ' 题未作答，确认提交试卷吗？提交后无法修改。'
          : '确认提交试卷吗？提交后无法修改。';
      this.$confirm(tip, '提交确认', {
        confirmButtonText: '确认提交',
        cancelButtonText: '再检查一下',
        type: 'warning'
      }).then(() => {
        this.doSubmit();
      }).catch(() => {});
    },
    // 超时自动提交
    autoSubmit() {
      this.$message.warning('考试时间已到，系统将自动提交试卷');
      this.doSubmit();
    },
    doSubmit() {
      if (this.submitting) {
        return;
      }
      this.submitting = true;
      api.hoj_customize_exam_submit({ recordId: this.record.recordId }).then((r) => {
        if (r.data.code === "200") {
          this.clearTimer();
          this.$message.success('试卷已提交');
          this.$router.replace('/portal/customize/exam/result?recordId=' + this.record.recordId);
        } else {
          this.$message.error(r.data.msg || '提交失败');
        }
      }).catch(() => {
        // 未登录(401)已由 common/api.js 统一跳转门户登录页
      }).finally(() => {
        this.submitting = false;
      });
    },
    sheetItemClass(problem) {
      if (this.record.status === '2') {
        return problem.isCorrect === '1' ? 'sheet-correct' : 'sheet-wrong';
      }
      return problem.userAnswer && problem.userAnswer.length > 0 ? 'sheet-answered' : '';
    },
    scrollToProblem(index) {
      let cards = document.querySelectorAll('.problem-card');
      if (cards[index]) {
        cards[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    goBack() {
      this.$router.push('/portal/customize/exam').catch(() => {});
    }
  }
};
</script>
<style scoped>
.answer-page {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 20px;
  box-sizing: border-box;
}
.answer-header {
  max-width: 1200px;
  margin: 0 auto 20px auto;
  background-color: #fff;
  border-radius: 8px;
  padding: 18px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 100;
}
.header-left {
  display: flex;
  align-items: center;
}
.exam-title {
  font-size: 18px;
  color: #303133;
  margin: 0 12px 0 0;
}
.submit-status {
  font-size: 12px;
  color: #67C23A;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}
.timer {
  font-size: 15px;
  color: #409EFF;
  font-weight: bold;
}
.timer.danger {
  color: #F56C6C;
}
.answer-body {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}
.problem-area {
  flex: 1;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 60px 0;
  background-color: #fff;
  border-radius: 8px;
}
.problem-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 22px 25px;
  margin-bottom: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.problem-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.problem-index {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background-color: #409EFF;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  margin-right: 12px;
}
.problem-score {
  margin-left: auto;
  font-size: 13px;
  color: #909399;
}
.result-tag {
  margin-left: 12px;
}
.problem-content {
  font-size: 15px;
  color: #303133;
  line-height: 1.7;
  margin-bottom: 18px;
  white-space: pre-wrap;
}
.option-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.option-item {
  padding: 10px 15px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  transition: all 0.2s;
}
.option-item:hover {
  background-color: #f5f7fa;
}
.option-label {
  font-weight: bold;
  margin-right: 8px;
}
.option-content {
  color: #303133;
}
.option-item.option-correct {
  background-color: #f0f9eb;
  border-color: #67C23A;
}
.option-item.option-wrong {
  background-color: #fef0f0;
  border-color: #F56C6C;
}
.answer-analysis {
  margin-top: 18px;
  padding-top: 15px;
  border-top: 1px dashed #ebeef5;
  font-size: 14px;
  color: #606266;
}
.analysis-item {
  margin-right: 30px;
}
.analysis-item .correct {
  color: #67C23A;
}
.answer-sheet {
  width: 240px;
  flex-shrink: 0;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  height: fit-content;
  position: sticky;
  top: 100px;
}
.sheet-title {
  font-size: 16px;
  color: #303133;
  margin: 0 0 15px 0;
}
.sheet-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  margin-bottom: 15px;
}
.sheet-item {
  height: 32px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  transition: all 0.2s;
}
.sheet-item:hover {
  border-color: #409EFF;
  color: #409EFF;
}
.sheet-item.sheet-answered {
  background-color: #409EFF;
  border-color: #409EFF;
  color: #fff;
}
.sheet-item.sheet-correct {
  background-color: #67C23A;
  border-color: #67C23A;
  color: #fff;
}
.sheet-item.sheet-wrong {
  background-color: #F56C6C;
  border-color: #F56C6C;
  color: #fff;
}
.sheet-legend {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #909399;
  margin-bottom: 12px;
}
.legend-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 5px;
}
.legend-dot.answered {
  background-color: #409EFF;
}
.legend-dot.unanswered {
  background-color: #fff;
  border: 1px solid #dcdfe6;
}
.sheet-summary {
  padding-top: 12px;
  border-top: 1px solid #ebeef5;
  font-size: 13px;
  color: #606266;
  text-align: center;
}
</style>
